/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@progress/kendo-angular-dropdowns/dist/es/templates/template-context.directive';
import * as i2 from '@angular/common';
import * as i3 from '@progress/kendo-angular-dropdowns/dist/es/list-item.directive';
import * as i4 from '@progress/kendo-angular-dropdowns/dist/es/selectable.directive';
import * as i5 from '@progress/kendo-angular-dropdowns/dist/es/selection.service';
import * as i6 from '@progress/kendo-angular-dropdowns/dist/es/list.component';
const styles_ListComponent:any[] = ([] as any[]);
export const RenderType_ListComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ListComponent,data:{}});
function View_ListComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['\n            ']))],(null as any),
      (null as any));
}
function View_ListComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵand(16777216,(null as any),(null as any),2,(null as any),
      View_ListComponent_3)),i0.ɵdid(16384,(null as any),0,i1.TemplateContextDirective,
      [i0.ViewContainerRef],{templateContext:[0,'templateContext']},(null as any)),
      i0.ɵpod({templateRef:0,$implicit:1}),(_l()(),i0.ɵand(0,(null as any),(null as any),
          0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _ck(_v,2,0,_co.template.templateRef,(<any>_v.parent).context.$implicit);
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
function View_ListComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.getText((<any>_v.parent).context.$implicit);
    _ck(_v,0,0,currVal_0);
  });
}
function View_ListComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),11,'li',[['kendoDropDownsSelectable',
      ''],['role','option']],[[1,'id',0],[1,'tabIndex',0],[2,'k-state-focused',(null as any)],
      [2,'k-state-selected',(null as any)],[1,'aria-selected',0]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>i0.ɵnov(_v,4).onClick($event)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(278528,(null as any),0,i2.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      i0.ɵpod({'k-item':0}),i0.ɵdid(16384,[[1,4]],0,i3.ListItemDirective,[i0.ElementRef],
          (null as any),(null as any)),i0.ɵdid(16384,(null as any),0,i4.SelectableDirective,
          [i5.SelectionService],{index:[0,'index'],multipleSelection:[1,'multipleSelection']},
          (null as any)),(_l()(),i0.ɵted((null as any),['\n            '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ListComponent_2)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n            '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ListComponent_4)),
      i0.ɵdid(16384,(null as any),0,i2.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n        ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_5:any = _ck(_v,2,0,true);
        _ck(_v,1,0,currVal_5);
        const currVal_6:any = _v.context.index;
        const currVal_7:any = _co.multipleSelection;
        _ck(_v,4,0,currVal_6,currVal_7);
        const currVal_8:any = _co.template;
        _ck(_v,7,0,currVal_8);
        const currVal_9:boolean = !_co.template;
        _ck(_v,10,0,currVal_9);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = ((_co.optionPrefix + '-') + _co.getValue(_v.context.$implicit));
        const currVal_1:any = (0 - 1);
        const currVal_2:any = i0.ɵnov(_v,4).focusedClassName;
        const currVal_3:any = i0.ɵnov(_v,4).selectedClassName;
        const currVal_4:any = i0.ɵnov(_v,4).ariaSelected;
        _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
      });
}
export function View_ListComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(671088640,1,{items:1}),i0.ɵqud(402653184,2,{content:0}),
      (_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,[[2,0],['content',
          1]],(null as any),10,'div',[['unselectable','on']],[[4,'maxHeight',(null as any)]],
          (null as any),(null as any),(null as any),(null as any))),i0.ɵdid(278528,
          (null as any),0,i2.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,
              i0.Renderer],{ngClass:[0,'ngClass']},(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n    '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),6,'ul',[['role',
          'listbox']],[[1,'id',0],[1,'aria-hidden',0]],(null as any),(null as any),
          (null as any),(null as any))),i0.ɵdid(278528,(null as any),0,i2.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{ngClass:[0,
              'ngClass']},(null as any)),i0.ɵpod({'k-list':0,'k-reset':1}),(_l()(),
          i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ListComponent_1)),i0.ɵdid(802816,(null as any),
          0,i2.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,
              'ngForOf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵted((null as any),['\n  ']))],
      (_ck,_v) => {
        var _co:i6.ListComponent = _v.component;
        const currVal_1:any = _co.setContainerClasses();
        _ck(_v,4,0,currVal_1);
        const currVal_4:any = _ck(_v,8,0,true,true);
        _ck(_v,7,0,currVal_4);
        const currVal_5:any = _co.data;
        _ck(_v,11,0,currVal_5);
      },(_ck,_v) => {
        var _co:i6.ListComponent = _v.component;
        const currVal_0:any = _co.getHeight();
        _ck(_v,3,0,currVal_0);
        const currVal_2:any = _co.id;
        const currVal_3:boolean = !_co.show;
        _ck(_v,6,0,currVal_2,currVal_3);
      });
}
export function View_ListComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'kendo-list',([] as any[]),
      (null as any),(null as any),(null as any),View_ListComponent_0,RenderType_ListComponent)),
      i0.ɵdid(4374528,(null as any),0,i6.ListComponent,[i5.SelectionService],(null as any),
          (null as any))],(null as any),(null as any));
}
export const ListComponentNgFactory:i0.ComponentFactory<i6.ListComponent> = i0.ɵccf('kendo-list',
    i6.ListComponent,View_ListComponent_Host_0,{data:'data',selected:'selected',focused:'focused',
        textField:'textField',valueField:'valueField',height:'height',template:'template',
        show:'show',id:'id',optionPrefix:'optionPrefix',multipleSelection:'multipleSelection'},
    {onClick:'onClick'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/$$_gendir/~/@progress/kendo-angular-dropdowns/dist/es/list.component.ngfactory.ts